import { z } from "zod";

/**
 * Parametros de paginacao aceitos por toda rota de listagem da API.
 * Reutilize este schema com `.extend()` em vez de redeclarar cursor/limite.
 */
export const consultaPaginadaSchema = z.object({
  cursor: z.string().min(1).optional(),
  limite: z.coerce.number().int().min(1).max(200).default(50),
  desde: z.coerce.date().optional(),
  ate: z.coerce.date().optional(),
});

export type ConsultaPaginada = z.infer<typeof consultaPaginadaSchema>;

/** Envelope de resposta paginada. `proximoCursor: null` significa fim da lista. */
export function paginaSchema<T extends z.ZodTypeAny>(item: T) {
  return z.object({
    dados: z.array(item),
    proximoCursor: z.string().nullable(),
  });
}

export type Pagina<T> = {
  dados: T[];
  proximoCursor: string | null;
};
